export const isNullOrEmpty = (val) => {
    return val == null || val == "" || val?.trim() == ""
}